$(document).ready(function(){
    
   footer_accordion();
});

function footer_accordion(){
  if($(window).width()<750)
  {
      $('.custom_accordian').addClass('ced-accordion');
      $('.ced-accordion').next().addClass('ced-accordion-content');
      $('.ced-accordion').click(function(){
      var accr = $(this).text();
      accr = accr.replace(" ", "");
      if($(this).hasClass('active')){
         $(this).removeClass('active');
         $(this).next().removeClass('active');
      }
      else{
        $(this).addClass('active');
        $(this).next().addClass('active');
      }
      $('.ced-accordion').each(function(){
        var acc = $(this).text();
        acc = acc.replace(" ", "");
        if(accr != acc){
          $(this).removeClass('active');
          $(this).next().removeClass('active');
        }
      });
    })
  }
}
